<template>
  <header class="header-glass">
    <!-- 左侧：汉堡菜单 -->
    <div class="menu-section">
      <div class="hamburger-menu" @click="$emit('toggle-menu')">
        <div class="hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span class="menu-text">MENU</span>
      </div>
    </div>
    <!-- 中间：品牌名称和图标 -->
    <div class="brand-section">
      <router-link to="/" class="brand-link">
        <img
          src="@/assets/static/ochrm-logo.png"
          alt="logo"
          class="brand-logo"
        />
      </router-link>
    </div>
    <!-- 右侧：社交媒体图标和语言选择 -->
    <div class="social-section">
      <!-- <div
        class="social-icon facebook-icon"
        @click="$emit('open-share-modal', 'facebook')"
        :title="$t('shareModal.shareToFacebook')"
      >
        <i class="fab fa-facebook-f"></i>
      </div>
      <div
        class="social-icon linkedin-icon"
        @click="$emit('open-share-modal', 'linkedin')"
        :title="$t('shareModal.shareToLinkedIn')"
      >
        <i class="fab fa-linkedin-in"></i>
      </div> -->
      <div class="language-selector" @click="$emit('open-language-dialog')">
        <!-- <span
          v-if="
            languages.find((lang) => lang.code === currentLanguage)?.flagCode
          "
          :class="`fi fi-${
            languages.find((lang) => lang.code === currentLanguage)?.flagCode
          }`"
          class="language-flag"
        /> -->
        <!-- <span v-else class="language-flag">🌐</span> -->
        <span class="language-flag">Language</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    languages: Array,
    currentLanguage: String,
  },
};
</script>

<style scoped>
.header-glass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  height: 70px;
  background: rgba(60, 60, 60, 0.55);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  position: fixed;
  top: 0;
  z-index: 1000;
  max-width: 100%;
  width: 100%;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
}

/* 其它样式可复用原 header 区域 */
.menu-section,
.brand-section,
.social-section {
  display: flex;
  align-items: center;
}
.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.brand-logo {
  max-width: 160px;
  max-height: 56px;
  width: auto;
  height: 56px;
  object-fit: contain;
  margin: 0 auto;
}
.menu-text {
  font-size: 14px;
  font-weight: 500;
  color: white;
  letter-spacing: 1px;
}
.hamburger-menu {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: white;
}
.hamburger-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 20px;
  height: 16px;
  margin-right: 8px;
}
.hamburger-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: white;
}
.social-section {
  gap: 15px;
}
.social-icon {
  width: 24px;
  height: 24px;
  color: white;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.social-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}
.language-selector {
  min-width: 36px;
  width: auto;
  height: 36px;
  padding: 0 8px;
  color: white;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
}
.language-selector:hover {
  background: rgba(255, 255, 255, 0.2);
}
.language-flag {
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
}
@media (max-width: 768px) {
  .header-glass {
    padding: 0 20px;
    height: 60px;
  }
  .brand-logo {
    max-width: 120px;
    height: 40px;
  }
  .menu-text {
    font-size: 12px;
  }
  .hamburger-icon {
    width: 18px;
    height: 14px;
  }
  .social-icon {
    width: 20px;
    height: 20px;
  }

  /* language按钮在移动端宽度随文字自适应 */
  .language-selector {
    width: auto;
    min-width: 36px;
    height: 28px;
    padding: 0 10px;
  }

  .language-flag {
    font-size: 12px;
    font-weight: 600;
  }
}
</style>
